/*
 * The Rich Cream landing page (rc-lp-*): video rows + before/after track arrows.
 * Video: click a play button → that card's <video> starts (with controls); any other
 * playing card pauses. Degrades to the poster image without JavaScript.
 */
(function () {
  'use strict';

  var current = null;

  function stop(card) {
    if (!card) return;
    var video = card.querySelector('video');
    if (video) video.pause();
    card.classList.remove('is-playing');
  }

  function initVideoRows(scope) {
    var cards = (scope || document).querySelectorAll('[data-rc-video]:not([data-rc-ready])');
    Array.prototype.forEach.call(cards, function (card) {
      card.setAttribute('data-rc-ready', '');
      var button = card.querySelector('[data-rc-play]');
      var video = card.querySelector('video');
      if (!button || !video) return;

      button.addEventListener('click', function () {
        if (current && current !== card) stop(current);
        current = card;
        card.classList.add('is-playing');
        video.setAttribute('controls', '');
        video.muted = false;
        var playing = video.play();
        if (playing && playing.catch) {
          playing.catch(function () {
            // Autoplay with sound may be blocked: fall back to a muted start.
            video.muted = true;
            video.play().catch(function () {});
          });
        }
      });

      video.addEventListener('ended', function () {
        stop(card);
        if (current === card) current = null;
      });
    });
  }

  /*
   * Before/after track: prev/next arrows scroll the snap list one card at a time
   * (desktop); on touch the list simply swipes. Arrows disable at either end.
   */
  function initTracks(scope) {
    var tracks = (scope || document).querySelectorAll('[data-rc-track]:not([data-rc-ready])');
    Array.prototype.forEach.call(tracks, function (track) {
      track.setAttribute('data-rc-ready', '');
      var list = track.querySelector('[data-rc-track-list]');
      var prev = track.querySelector('[data-rc-prev]');
      var next = track.querySelector('[data-rc-next]');
      if (!list || !prev || !next) return;

      function step() {
        var item = list.querySelector('li');
        if (!item) return list.clientWidth;
        var gap = parseFloat(getComputedStyle(list).columnGap || getComputedStyle(list).gap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = list.scrollWidth - list.clientWidth - 1;
        prev.disabled = list.scrollLeft <= 1;
        next.disabled = list.scrollLeft >= max;
      }
      prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: 'smooth' }); });
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function init(scope) {
    initVideoRows(scope);
    initTracks(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
